/* BackupTypeRenderer.js */

"use strict";
const ButtonControl = require("@gluenetworks/steve_ui_core").Control.Action.Button;
const InputTextControl = require("@gluenetworks/steve_ui_core").Control.Textfield.InputText;
const InputRadioControl = require("@gluenetworks/steve_ui_core").Control.OptionSelection.Single
    .InputRadio;
const InputCheckboxControl = require("@gluenetworks/steve_ui_core").Control.Boolean.InputCheckbox;
const DateControl = require("@gluenetworks/steve_ui_core").Control.Timestamp.DateTimePicker;
require("@progress/kendo-ui/js/kendo.daterangepicker");

/* global $ */
const _ = require("lodash");
class BackupTypeRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("backup-type-gl"); //TODO Setup the root Element
        this._rootElem.component = this._model;

        this._filterContainer = document.createElement("div");
        this._filterContainer.classList.add("filter-container");
        this._filterLabel = document.createElement("label");
        this._filterLabel.innerHTML = "";
        this._anchorForTooltip = document.createElement("u");
        this._anchorForTooltip.innerText = "supported OS";
        this._filter = new InputRadioControl({
            darkTheme: true,
            horizontal: true,
            options: [
                {
                    label: "Last successful",
                    value: "lastSuccessful",
                },
                {
                    label: "Name match",
                    value: "nameMatch",
                },
                {
                    label: "Date range",
                    value: "dateRange",
                },
            ],
            value: "lastSuccessful",
        });

        this._nameRegexInputEl = new InputTextControl({
            darkTheme: true,
            placeholder: "Name (regex)",
        });

        this._setDefaultCaptureCheckbox = new InputCheckboxControl({
            label: "Set the snapshot captured after restore as the default configuration",
            labelShown: true,
            value: false,
            darkTheme: true,
            disabled: false,
        });

        this._restoreWithMismatchCheckbox = new InputCheckboxControl({
            label: "Allow restore with OS or serial number mismatch",
            labelShown: true,
            value: false,
            darkTheme: true,
            disabled: false,
        });

        this._startDateControl = new DateControl({
            label: "Between",
            labelShown: true,
            value: "",
            darkTheme: true,
            disabled: false,
        });

        this._endDateControl = new DateControl({
            label: "And",
            labelShown: true,
            value: "",
            darkTheme: true,
            disabled: false,
        });

        this._cancelButton = new ButtonControl({
            label: "Cancel",
            darkTheme: true,
        });

        this._confirmButton = new ButtonControl({
            label: "Preview",
            darkTheme: true,
            active: true,
        });

        this._titleComponent = document.createElement("h2");
        this._titleComponent.innerText = this._model.titleText;

        this._messageBox = this._createMessageBox();

        this._countContainer = document.createElement("div");
        this._countContainer.classList.add("count-container");
        this._addCount();

        this._buttonContainer = document.createElement("button-container");

        this._footer = document.createElement("div");
        this._footer.classList.add("footer-container");
        this._footer.appendChild(this._countContainer);
        this._footer.appendChild(this._buttonContainer);

        this._typeContainer = document.createElement("div");
        this._typeContainer.classList.add("type-container");

        this._pickerControl = {};
        this._dateTimePickerComp = {};
        this._pickerId = {};
        this._checkExist = {};

        this._registerListeners();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _registerListeners() {
        this._filter.on("UserValue", (this._onFilterChange = this._onFilterChange.bind(this)));
        this._confirmButton.on(
            "UserClick",
            (this._onConfirmButtonClick = this._onConfirmButtonClick.bind(this))
        );
        this._cancelButton.on(
            "UserClick",
            (this._onCancelButtonClick = this._onCancelButtonClick.bind(this))
        );
    }

    _unregisterListeners() {
        this._confirmButton.removeAllListeners("UserClick");
        this._cancelButton.removeAllListeners("UserClick");
        this._filter.removeAllListeners("UserValue");
    }

    _checkForImpliedConfirm(event) {
        if (event.keyCode === 13) {
            // this._callStartCapture();
        }
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    shutdown() {
        this._unregisterListeners();
        let promArr = [
            this._filter.shutdown(),
            this._confirmButton.shutdown(),
            this._cancelButton.shutdown(),
        ];

        if (this._pickerControl["start"]) {
            promArr.push(this._pickerControl["start"].destroy());
        }

        if (this._pickerControl["end"]) {
            promArr.push(this._pickerControl["end"].destroy());
        }

        return Promise.all(promArr).then(
            () => {
                this._confirmButton = undefined;
                this._cancelButton = undefined;
                this._buttonContainer.remove();
                this._buttonContainer = undefined;
                this._titleComponent.remove();
                this._titleComponent = undefined;
                this._filter = undefined;
                this._filterLabel = undefined;
                this._filterContainer = undefined;
                this._typeContainer.remove();
                this._typeContainer = undefined;
                this._messageBox.remove();
                this._messageBox = undefined;
                this._model = undefined;
                this._rootElem.remove();
                this._rootElem = undefined;
            },
            (err) => {
                this._model.logger.warn(err, "CreateQuestionRenderer.shutdown() error");
            }
        );
    }

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        return new Promise((resolve /*,reject*/) => {
            if (!this._rootElem.hasChildNodes()) {
                const listOfSUpportedOs = this._createList(this.model._supportedOsList);
                this._anchorForTooltip.setAttribute("title", listOfSUpportedOs);
                this._rootElem.appendChild(this._titleComponent);
                this._rootElem.appendChild(this._messageBox);
                this._rootElem.appendChild(this._filterContainer);
                this._filterContainer.appendChild(this._filter.renderer.rootElement);
                this._rootElem.appendChild(this._typeContainer);
                this._rootElem.appendChild(this._setDefaultCaptureCheckbox.renderer.rootElement);
                this._rootElem.appendChild(this._restoreWithMismatchCheckbox.renderer.rootElement);
                this._rootElem.appendChild(this._footer);
                // this._rootElem.appendChild(this._buttonContainer);
                this._buttonContainer.appendChild(this._cancelButton.renderer.rootElement);
                this._buttonContainer.appendChild(this._confirmButton.renderer.rootElement);

                // setTimeout(() => {
                if (this._model._selection) {
                    this._filter.setValue(this._model._selection.filter, true);
                    this._onFilterChange(this._model._selection.filter);
                    this._setDefaultCaptureCheckbox.setValue(
                        this._model._selection.setAsDefaultSnapshot,
                        true
                    );
                    this._restoreWithMismatchCheckbox.setValue(
                        this._model._selection.restoreWithMismatch,
                        true
                    );
                }
                // }, 800);
            }
            resolve();
        });
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START PRIVATE RENDER METHODS            */
    /*******************************************/

    // TODO Private Render Methods here

    _createMessageBox() {
        const messageStart = document.createElement("p");
        messageStart.innerHTML = `Select the configuration to restore by choosing the Backup using:`;
        const messageFull = document.createElement("div");
        messageFull.classList.add("supported-os-msg-container");
        messageFull.appendChild(messageStart);
        return messageFull;
    }

    _createList(array) {
        const uniqueSet = new Set(array);
        const listItems = [...uniqueSet].map((item) => item || "Empty OS");
        return listItems.join("\n");
    }
    _addCount() {
        let message = "",
            isWarning = false;
        const pluralSuffix = this._model._selectedDeviceIds.length > 1 ? "s" : "";
        if (this._model._unsupportedDevices && this._model._unsupportedDevices.length > 0) {
            isWarning = true;
            message += `<base-icon-gl data-icon="common.warning"></base-icon-gl> ${this._model._unsupportedDevices.length} out of ${this._model._selectedDeviceIds.length} selected device${pluralSuffix} run an unsupported OS`;
        } else {
            message += `${this._model._selectedDeviceIds.length} selected device${pluralSuffix}`;
        }

        this._countContainer.innerHTML = message;
        if (isWarning) {
            this._countContainer.classList.add("warning");
        }
    }

    _renderPickerWrapper(type = "start") {
        const wrapper = document.createElement("div");
        wrapper.classList.add("date-range-picker");
        const labelEl = document.createElement("label");
        labelEl.innerText = type === "start" ? "Between" : "And";
        wrapper.appendChild(labelEl);
        this._dateTimePickerComp[type] = document.createElement("input");
        this._pickerId[type] =
            type + "dtRangePicker" + new Date().getTime() + parseInt(Math.random() * 100, 10);
        this._dateTimePickerComp[type].setAttribute("id", this._pickerId[type]);
        wrapper.appendChild(this._dateTimePickerComp[type]);
        this._typeContainer.appendChild(wrapper);
        this._checkExist[type] = setInterval(() => {
            if ($("#" + this._pickerId[type]).length > 0) {
                // console.log("Exists!");
                clearInterval(this._checkExist[type]);
                this.renderPicker(type);
            }
        }, 25);
    }

    renderPicker(type) {
        // console.log("render");
        const self = this;
        if (self._pickerControl && self._pickerControl[type]) {
            self._pickerControl[type].destroy();
            self._pickerControl[type] = undefined;
        }

        if ($("#" + this._pickerId[type]).length <= 0) {
            return Promise.resolve();
        }

        const defaultDateValue =
            type === "start" ? new Date(Date.now() - 7 * 24 * 60 * 60 * 1000) : new Date();

        const pickerValue = _.get(this._model._selection, "value." + type, defaultDateValue);
        const startDateVal = _.get(
            this._model._selection,
            "value.start",
            new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
        );

        $("#" + this._pickerId[type]).kendoDateTimePicker({
            componentType: "modern",
            footer: false,
            value: pickerValue,
            format: "dddd, MMMM dd, yyyy, hh:mm tt zzz",
            open: function () {
                self._pickerControl[type] = this;
                self._pickerControl[type].popup.element[0].classList.add("dark");
                // self._pickerControl[type].popup.element[0].parentElement.classList.add("dark");
            },
            change: function () {
                let value = this.value();
                self._pickerControl[type].timeView._currentlySelected = value;
                self._onDateOk(value);
                if (type === "start" && self._pickerControl["end"]) {
                    self._pickerControl["end"].min(value);
                }
            },
            close: function (/* evt */) {
                self._pickerControl[type].value(
                    self._pickerControl[type].timeView._currentlySelected
                );
                if (type === "start" && self._pickerControl["end"]) {
                    self._pickerControl["end"].min(
                        self._pickerControl[type].timeView._currentlySelected
                    );
                    if (self._pickerControl["end"].value() < self._pickerControl[type].value()) {
                        self._pickerControl["end"].value(
                            self._pickerControl[type].timeView._currentlySelected
                        );
                    }
                }
                self._onDateOk(self._pickerControl[type].timeView._currentlySelected);
            },
        });
        this._pickerType = "kendoDateTimePicker";
        this._pickerControl[type] = $("#" + this._pickerId[type]).data(this._pickerType);
        if (type === "end") {
            this._pickerControl[type].min(startDateVal);
        }

        this._pickerControl[type].timeView._currentlySelected = pickerValue;
    }

    /*******************************************/
    /* END PRIVATE RENDER METHODS              */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onCancelButtonClick() {
        this.model.cancelAction();
    }

    _onFilterChange(val) {
        this._selectedType = val;
        switch (val) {
            case "nameMatch":
                this._typeContainer.innerHTML = "";
                this._typeContainer.appendChild(this._nameRegexInputEl.renderer.rootElement);
                if (
                    this._model._selection &&
                    this._model._selection.filter &&
                    this._model._selection.filter === "nameMatch"
                ) {
                    this._nameRegexInputEl.setValue(this._model._selection.value);
                }
                break;
            case "dateRange":
                this._typeContainer.innerHTML = "";
                // this._typeContainer.appendChild(this._startDateControl.renderer.rootElement);
                // this._typeContainer.appendChild(this._endDateControl.renderer.rootElement);
                this._renderPickerWrapper();
                this._renderPickerWrapper("end");
                break;
            case "lastSuccessful":
            default:
                this._typeContainer.innerHTML = "";
                break;
        }
    }

    _onDateOk(/*val*/) {
        // const _picker = $("#" + this._pickerId).data(this._pickerType);
        // _picker.range(val);
        // const date = this._model.getDateTime(this._schedulePropName);
        // console.log(date);
        // console.log(val);
    }

    _onDateCancel() {
        // RendererUtils.hideElements(this._popupElem);
        document.removeEventListener("click", this._onBodyClick);
    }

    _onConfirmButtonClick() {
        const filter = this._filter.value;
        let value;
        const setAsDefaultSnapshot = this._setDefaultCaptureCheckbox.getValue();
        const restoreWithMismatch = this._restoreWithMismatchCheckbox.getValue();
        switch (filter) {
            case "nameMatch":
                value = this._nameRegexInputEl.getValue();
                break;
            case "dateRange":
                value = {
                    start: this._pickerControl["start"].timeView._currentlySelected,
                    end: this._pickerControl["end"].timeView._currentlySelected,
                };
                break;
            case "lastSuccessful":
            default:
                value = "";
                break;
        }

        this._model.resolve({
            filter,
            value,
            setAsDefaultSnapshot,
            restoreWithMismatch,
        });
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    _callStartCapture() {
        const filter = this._filter.value;
        this._model.startCapture(undefined, filter);
    }

    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/
}

module.exports = BackupTypeRenderer;
